<template>
    <div class="d-flex flex-column overflow-auto h-100">
        <div class="p-4 flex-grow-1 overflow-auto">
            <div class="mb-3-rem">
               <v-label>{{ $t("res_Label_EmailTo") }} <span>*</span></v-label>
                <StructureUserSelector :acceptExternalEmails="true" :showInternalUsers="true" :showExternalUsers="false" :showInternalStructures="false"
                        :showExternalStructures="false" :excludeSelf="false" :isMultiple="true" @structureUserSelectChanged="toEmailChanged" 
                        :selectedStructureUsersList="toEmail" :addressBook_header="$t('SelectEmailTo')" :disabled="this.isSent">
                </StructureUserSelector>
            </div>
            <div class="mb-3-rem">
               <v-label>{{ $t("res_Label_EmailCC")}}</v-label>
                <StructureUserSelector :acceptExternalEmails="true" :showInternalUsers="true" :showExternalUsers="false" :showInternalStructures="false"
                        :showExternalStructures="false" :excludeSelf="false" :isMultiple="true" @structureUserSelectChanged="toEmailCCChanged" 
                        :selectedStructureUsersList="emailCC" :addressBook_header="$t('SelectEmailCC')">
                </StructureUserSelector>
            </div>
            <div class="mb-3-rem">
               <v-label>{{ $t("res_Label_Subject") }} <span>*</span></v-label>
                <v-text-field solo v-model='subject'></v-text-field>
            </div>
            <div>
                <v-label>{{ $t("res_Label_Body") }} <span>*</span></v-label>
                <McWysiwyg v-model="body" :options="editorOptions" :key="trigger" v-if="dialogModelShow == true" />
            </div>
        </div>
        <v-card-actions class="top-shadow gap-3">
            <v-btn class="light-blue flex-1" @click="closeDialog">{{ $t("res_ButtonText_Cancel") }}</v-btn>
            <v-btn class="primary flex-1" @click="sendNotifyEmail">{{ $t("res_ButtonText_SendEmail") }}</v-btn>
        </v-card-actions>
    </div>
</template>

<script>
    import { McWysiwyg } from '@mycure/vue-wysiwyg'
    import constants from "@/assets/js/constants.js"
    import StructureUserSelector from './StructureUserSelector.vue'
    import axios from "axios"
    import * as utils from '@/assets/js/common.js'

    export default {
        name: 'NotifyEmail',
        components: { McWysiwyg, StructureUserSelector },
        props: 
        {
            isSent: { type: Boolean, default: false },
            toUserId: { type: Number, default: 0 },
			//toEmail: { type: String, default: '' },
            //emailCC: { type: String, default: '' },
            subject: { type: String, default: ''},
            documentId: { type: [String, Number], default: '0' },
            transferId: { type: [String, Number], default: '0' },
            dialogModelShow: { type: Boolean, default: false }
		},
        data: function () {
            return {
                toEmail: '',
                emailCC: '',
                body: '',
                trigger: 1,
                dialogWasOpen: false,
                editorOptions: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'], // Basic font styles
                        [{ 'header': 1 }, { 'header': 2 }], // Headers
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Lists
                        ['link', 'image', 'video'], // Media
                        ['clean'] // Remove formatting
                    ],
                    formats: ['header', 'bold', 'italic', 'underline', 'strike', 'list', 'bullet', 'link', 'image', 'video', 'font'],
                    fontNames: ['Arial', 'Helvetica', 'Georgia', 'Times New Roman', 'Courier New'],
                    fontSize: ['10px', '12px', '14px', '16px', '18px', '24px', '36px']
                }
            }
        },
        methods: 
        {
            getUserStructures(value)
            {
                var signatoryUserIds = value
                axios.get(constants.baseApiUrl + 'StructureUser/GetUsersForMultiSelect?userIds=' + signatoryUserIds) 
                .then(res => 
                        {
                            if (res != undefined && res.data != null && res.data != undefined) {
                                var selectedToUser = [{id: res.data[0].id, external: res.data[0].external, isUser: res.data[0].isUser, name: res.data[0].name,email:res.data[0]?.email}];
                                this.toEmail = utils.handleFirstElement(selectedToUser); 
                            }
                        })
                        .catch(() => console.log(err))
                        .finally(() => window.hideLoading())
            },
            getNotificationTemplate()
            {
                if (this.documentId != null && this.documentId != "" && this.documentId != undefined)
                {
                    window.showLoading()
                    axios.get(constants.baseApiUrl + 'Letter/GetDispatchTemplate?documentId='+this.documentId
                        +'&transferId='+this.transferId+'&type=notification')
                        .then(res => 
                        {
                            this.body = "";
                            this.body =  res.data[0].body;
                            this.trigger++;
                        })
                        .catch(() => console.log(err))
                        .finally(() => window.hideLoading())
                }
                else
                {
                    this.body = "";
                    this.trigger++;
                }
            },
            toEmailChanged(items)
            {
                this.toEmail = utils.handleFirstElement(items);
            },
            toEmailCCChanged(items)
            {
                this.emailCC = utils.handleFirstElement(items);
            },
            sendNotifyEmail() 
            {
                  var toEmailList="";
                  var emailCCList=""; 
                  
                if (this.toEmail.length == 0 || this.subject == '' || this.body == '') 
                    return window.showAlert('res_Msgs_FillRequired', 'warning')

                var toEmailList = this.toEmail.filter(x => x.email).map(x => x.email).join(', ')
                if(this.emailCC.length > 0)
                    emailCCList = this.emailCC.filter(x => x.email).map(x => x.email).join(', ')

                var user = JSON.parse(sessionStorage.getItem("user"));

                var emailParam = {
                    fromEmail: user.profile.Email,
                    toEmail: toEmailList,
                    body: this.body,
                    subject: this.subject,
                    emailCC: emailCCList
                }

                window.showLoading()
                axios.post(constants.baseApiUrl + 'Followup/NotifyEmail', emailParam, { headers: constants.headers })
                    .then(res => 
                    {
                        if(res.data != null && res.data=='Success')
                        {
                            this.clearData()
                            this.closeDialog()
                            window.showAlert('res_Msgs_EmailDispatched', 'success')
                        }
                        else
                        {
                            window.showAlert('res_Msgs_Warning', 'success')
                        }
                    })
                    .catch(err => console.warn(err))
                    .finally(() => window.hideLoading())
            },
            closeDialog() 
            {
                this.clearData();
                this.dialogWasOpen = false;
                this.$emit('closeDialog');
            },
            clearData() 
            {
                this.toEmail = '';
                this.emailCC = '' ;
                this.subject='';
                this.body = "";
                this.emailParam = { subject: '', body: '' };
            },
            validateEmail(email) {
                if(email == null || email == "")
                    return true;
                // Check if email contains only spaces
                if (email.trim() === "")
                    return false;

                // Check if email contains '@' character
                if (!email.includes('@'))
                    return false;

                // Check if email contains '@@'
                if (email.includes('@@'))
                    return false;

                // Check if email contains spaces
                if (/\s/.test(email))
                    return false;

                // Split email into local and domain parts
                const [localPart, domainPart] = email.split('@');

                // Check if local part is empty or starts/ends with a dot
                if (!localPart || localPart.startsWith('.') || localPart.endsWith('.'))
                    return false;

                // Check if domain part is empty or starts/ends with a dot
                if (!domainPart || domainPart.startsWith('.') || domainPart.endsWith('.'))
                    return false;

                // Check if domain part contains a dot (to ensure a top-level domain is present)
                if (!domainPart.includes('.'))
                    return false;

                // Regular expression to check for a valid domain
                const domainRegex = /^(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)\.)*(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9]))\.([a-zA-Z]{2,})$/;

                // Regular expression to check for a valid IP address
                const ipRegex = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])$/;

                // Check if domain part is an invalid IP address
                if (domainRegex.test(domainPart) || ipRegex.test(domainPart))
                    return true;
                else
                    return false;
            }
        },
        updated()
        {
            if (this.dialogModelShow && this.wasOldDocument) {
                this.wasOldDocument = false
                this.getNotificationTemplate();

                if (this.isSent) {
                    this.getUserStructures(this.toUserId);
                }
            }
        },
        mounted() 
        {
            if(this.emailCC == null)
                this.emailCC = []
            
            this.getNotificationTemplate();

            if (this.isSent) {
                this.getUserStructures(this.toUserId);
            }
        },
        watch: 
        {
            documentId: function (newVal, oldVal) {
                if(oldVal != newVal)
                {
                    this.wasOldDocument = true; 
                }
            }
        }
    }
</script>